import { API } from "@/lib/api";
import {
  APIService,
  FetchListRequest,
  SuccessFetchListResponse,
} from "@/services/api";
import {
  ReadAvailableEmailRecipient,
  ReadEmailRecipient,
} from "@/types/emailRecipient";

const EmailRecipientsServiceAPI = new APIService(API.Emails);

export const EmailRecipientsService = {
  getRecipients: (
    emailTypeId: string,
    fetchParams?: FetchListRequest<ReadEmailRecipient>,
  ) =>
    EmailRecipientsServiceAPI.getList<
      SuccessFetchListResponse<ReadEmailRecipient>
    >(fetchParams, `/types/${emailTypeId}/recipients`),
  getAvailable: (
    emailTypeId: string,
    fetchParams?: FetchListRequest<ReadAvailableEmailRecipient>,
  ) =>
    EmailRecipientsServiceAPI.getList<
      SuccessFetchListResponse<ReadAvailableEmailRecipient>
    >(fetchParams, `/types/${emailTypeId}/recipients/available`),
  addUsers: (emailTypeId: string, userIds: string[]) =>
    EmailRecipientsServiceAPI.patch("recipients", {
      email_type_id: emailTypeId,
      add: userIds,
    }),
  removeUsers: (emailTypeId: string, userIds: string[]) =>
    EmailRecipientsServiceAPI.patch("recipients", {
      email_type_id: emailTypeId,
      delete: userIds,
    }),
};
